import Link from "next/link";
import { useState } from "react";
import { NextSeo } from "next-seo";
import dynamic from "next/dynamic";
import ErrorPage from "next/error";
import { useRouter } from "next/router";
import Layout from "@/components/layout/blog";

const Vacancy = dynamic(() => import("@/components/careers/vacancy"), {
  suspense: true,
});

export default function SocialMediaExecutive() {
  const router = useRouter();
  const post = router.query;
  const [isHovering, setIsHovering] = useState(false);

  if (!router.isFallback && !post) {
    return <ErrorPage statusCode={404} />;
  }

  const handleMouseEnter = () => {
    setIsHovering(true);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
  };

  return (
    <Layout>
      <NextSeo
        title="Social Media Executive needed for IS Auditr"
        canonical="https://isauditr.com/careers/social-media-executive"
        description="If you have knowledge of SEO and SMM, we want to hear from you! We are looking to hire a passionate Social Media Executive - apply now!"
        keywords="SEO, SMM, Social Media Executive, Social Media Manager"
        twitter={{
          cardType: "summary_large_image",
          site: "@isauditr",
          handle: "@isauditr",
          creator: "@isauditr",
          title: "Social Media Executive needed for IS Auditr",
          description:
            "If you have knowledge of SEO and SMM, we want to hear from you! We are looking to hire a passionate Social Media Executive - apply now!",
        }}
        openGraph={{
          type: `article`,
          locale: `en_US`,
          siteName: "IS Auditr",
          title: "Social Media Executive needed for IS Auditr",
          description:
            "If you have knowledge of SEO and SMM, we want to hear from you! We are looking to hire a passionate Social Media Executive - apply now!",
          url: `https://isauditr.com/careers/social-media-executive`,
          publisherName: "IS Auditr",
          publisherLogo: "https://isauditr.com/images/logo.svg",
        }}
      />

      {router.isFallback ? (
        <div>Loading…</div>
      ) : (
        <div
          data-elementor-type="single-post"
          data-elementor-id="1403"
          className="elementor elementor-1403 elementor-location-single post-645 post type-post status-publish format-standard has-post-thumbnail hentry category-uncategorized"
        >
          <section
            className="elementor-section elementor-top-section elementor-element elementor-element-0e39b24 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
            data-id="0e39b24"
            data-element_type="section"
          >
            <div className="elementor-container elementor-column-gap-no">
              <div
                className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-57f1572"
                data-id="57f1572"
                data-element_type="column"
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <div
                    className="elementor-element elementor-element-0e3bf1b elementor-align-left elementor-widget elementor-widget-button"
                    data-id="0e3bf1b"
                    data-element_type="widget"
                    data-widget_type="button.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="elementor-button-wrapper">
                        <Link
                          href="/careers"
                          className="elementor-button-link elementor-button elementor-size-sm elementor-animation-shrink"
                          role="button"
                        >
                          <span className="elementor-button-content-wrapper">
                            <span className="elementor-button-icon elementor-align-icon-left">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                id="fb1ba545-369a-4787-8f5c-a6afb4a11530"
                                data-name="Layer 1"
                                width="16.2764"
                                height="16.6475"
                                viewBox="0 0 16.2764 16.6475"
                              >
                                <path
                                  d="M16.2852,7.6343,3.498,7.6348,9.793,1.7412,8.4258.2812.3252,7.8652a1,1,0,0,0-.002,1.458l8.08,7.6055,1.3711-1.457L3.5723,9.6348H16.2852Z"
                                  transform="translate(-0.0088 -0.2813)"
                                ></path>
                              </svg>
                            </span>
                            <span className="elementor-button-text">
                              back to all
                            </span>
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="elementor-column elementor-col-66 elementor-top-column elementor-element elementor-element-e713e97"
                data-id="e713e97"
                data-element_type="column"
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <div
                    className="elementor-element elementor-element-15c6535 elementor-widget elementor-widget-theme-post-title elementor-page-title elementor-widget-heading"
                    data-id="15c6535"
                    data-element_type="widget"
                    data-widget_type="theme-post-title.default"
                  >
                    <div className="elementor-widget-container">
                      <h1 className="elementor-heading-title elementor-size-default">
                        Social Media Executive
                      </h1>
                    </div>
                  </div>

                  <div
                    className="elementor-element elementor-element-4bcecaf elementor-widget-divider--view-line elementor-widget elementor-widget-divider"
                    data-id="4bcecaf"
                    data-element_type="widget"
                    data-widget_type="divider.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="elementor-divider">
                        <span className="elementor-divider-separator"></span>
                      </div>
                    </div>
                  </div>

                  <div
                    className="elementor-element elementor-element-33acc19 elementor-widget elementor-widget-theme-post-content"
                    data-id="33acc19"
                    data-element_type="widget"
                    data-widget_type="theme-post-content.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="wp-block-columns">
                        <div
                          className="wp-block-column"
                          style={{ flexBasis: "300px" }}
                        >
                          <p>
                            <strong>Experience</strong>
                            <br />
                            2-4 years of relevant experience
                          </p>

                          <p>
                            <strong>Location</strong>
                            <br />
                            <meta charset="utf-8" />
                            Mohali, Punjab
                          </p>
                        </div>

                        <div className="wp-block-column">
                          <p>
                            We are looking for a witty and strategic social
                            media executive to oversee our company&apos;s
                            presence on a multitude of public platforms.
                          </p>
                        </div>
                      </div>

                      <div
                        style={{ height: "50px" }}
                        aria-hidden="true"
                        className="wp-block-spacer"
                      ></div>

                      <h4>
                        <strong>Job brief</strong>
                      </h4>

                      <p>
                        For this role, you should have a deep understanding of
                        how different social networks operate and be familiar
                        with Search Engine Optimization (SEO) for online
                        content. If you’re a tech-savvy professional with
                        interest in the latest trends in digital technologies,
                        we would like to meet you.
                      </p>

                      <p>
                        Ultimately, you should strengthen our online presence
                        and increase our brand awareness through effective
                        social media strategies and campaigns.
                      </p>

                      <div
                        style={{ height: "50px" }}
                        aria-hidden="true"
                        className="wp-block-spacer"
                      ></div>

                      <h4>Roles & Responsibilities</h4>

                      <ul>
                        <li>
                          Oversees all company social media accounts management
                        </li>
                        <li>
                          Develops engaging, creative, innovative content for
                          regularly scheduled posts, which enlighten audiences
                          and promote brand-focused messages
                        </li>
                        <li>
                          Manages social media team members, including
                          copywriters and other content creators, by overseeing
                          their work and offering guidance or direction
                        </li>
                        <li>
                          Audits and analyses social media presences, including
                          digital advertising costs and returns
                        </li>
                        <li>
                          Analyses social media campaigns with tracking systems
                          to gather visitor data and determine efficacy and
                          areas for social media campaign improvement
                        </li>
                        <li>
                          Conducting keyword research and using SEO best
                          practices to increase traffic to the company website.
                        </li>
                        <li>
                          Creating compelling headlines and body copy that will
                          capture the attention of the target audience.
                        </li>
                        <li>
                          Identifying customers’ needs and recommending new
                          content to address gaps in the company&apos;s current
                          content.
                        </li>
                      </ul>

                      <div
                        style={{ height: "50px" }}
                        aria-hidden="true"
                        className="wp-block-spacer"
                      ></div>

                      <h4>
                        <strong>Requirements and skills</strong>
                      </h4>

                      <ul>
                        <li>
                          Previous work experience as a Social Media Analyst,
                          Social Media Coordinator or similar role
                        </li>
                        <li>
                          Hands-on experience with social media platforms and
                          digital marketing campaigns
                        </li>
                        <li>
                          In-depth understanding of SEO, keyword research and
                          Google Analytics
                        </li>
                        <li>
                          Familiarity with online content (experience with
                          WordPress and content management systems is preferred)
                        </li>
                        <li>
                          Ability to identify target audience preferences and
                          trends
                        </li>
                        <li>Excellent communication skills</li>
                        <li>
                          Additional qualifications in digital technologies or
                          social media management is a plus
                        </li>
                      </ul>
                    </div>
                  </div>

                  <Link
                    rel="noopener"
                    href="https://www.linkedin.com/jobs/view/3531659753"
                    className="elementor-button-link elementor-button elementor-size-md"
                    role="button"
                    target="_blank"
                    style={{
                      fontFamily: '"Inter",Sans-serif',
                      fontSize: "16px",
                      fontWeight: 500,
                      textTransform: "capitalize",
                      fontStyle: "normal",
                      textDecoration: "none",
                      lineHeight: "1em",
                      letterSpacing: "-0.2px",
                      wordSpacing: "0px",
                      fill: "#E23125",
                      color: isHovering ? "#ffffff" : "#E23125",
                      backgroundColor: isHovering ? "#E23125" : "#FFFFFF00",
                      borderStyle: "solid",
                      borderWidth: "2px",
                      borderColor: "#E23125",
                      borderRadius: "60px 60px 60px 60px",
                      marginTop: "60px",
                    }}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  >
                    <span className="elementor-button-content-wrapper">
                      <span className="elementor-button-text">Apply Now</span>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </section>

          <section
            className="elementor-section elementor-top-section elementor-element elementor-element-62ac14c elementor-section-full_width elementor-section-height-default elementor-section-height-default"
            data-id="62ac14c"
            data-element_type="section"
          >
            <div className="elementor-container elementor-column-gap-no">
              <div
                className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-4734801"
                data-id="4734801"
                data-element_type="column"
              >
                <div
                  className="elementor-widget-wrap elementor-element-populated"
                  style={{
                    padding: "2%",
                    margin: "5%",
                    borderStyle: "solid",
                    borderWidth: "2px 0 0",
                    borderColor: "#E23125",
                    transition:
                      "background .3s,border .3s,border-radius .3s,box-shadow .3s",
                  }}
                >
                  <div
                    className="elementor-element elementor-element-f6f9ffc elementor-widget elementor-widget-heading"
                    data-id="f6f9ffc"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <div
                      className="elementor-widget-container"
                      style={{
                        margin: "5% 0%",
                      }}
                    >
                      <h3 className="elementor-heading-title elementor-size-default">
                        Check out some other job posts
                      </h3>
                    </div>
                  </div>

                  <Vacancy
                    title="ISO Consultant"
                    type="Full Time"
                    slug="iso-consultant"
                    location="Mohali, Punjab"
                    exceprt=" We are looking for a ISO Consultant with expertise in ISO 9001, SOC2, and ISO 27001 to join our team."
                  />

                  <Vacancy
                    title="Content Writer"
                    type="Full Time"
                    slug="content-writer"
                    location="Mohali, Punjab"
                    exceprt="We are looking for a Content Writer to join our editorial team and enrich our websites with new blog posts, guides and marketing copy."
                  />
                </div>
              </div>
            </div>
          </section>
        </div>
      )}
    </Layout>
  );
}
